const typography = {
  fontFamily: 'Roboto',
};

export default typography;
